import Vue from 'vue'
// Loading实例
var loadingInstance = null

/**
 * 开始加载loading
 */
export function loadingStart () {
  loadingInstance = Vue.prototype.$loading({ fullscreen: true })
}

/**
 * loading加载结束
 */
export function loadingFinish () {
  Vue.nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
    loadingInstance.close()
  })
}



// WEBPACK FOOTER //
// ./src/utils/loading.js